import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

const useLogout = () => {
    const { instance } = useMsal();

    const logout = useCallback(() => {
        // Clear all local storage except for dark_mode
        Object.keys(localStorage).forEach(key => {
            if (key !== 'dark_mode') {
                localStorage.removeItem(key);
            }
        });

        instance.logoutRedirect({
            postLogoutRedirectUri: "/welcome",
        });
    }, [instance]);

    return logout;
};

export default useLogout;